import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./home.scss";
import Widget from "../../components/widget/Widget";
import Featured from "../../components/featured/Featured";
import Chart from "../../components/chart/Chart";
import Table from "../../components/table/Table";
import AuthDetails from "../../../components/AuthDetails";
import UserProjects from "../../../components/userProjects";
import Dataloader from "../../components/dataloader/Dataloader";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddBoxIcon from '@mui/icons-material/AddBox';
import React, { useState } from 'react';
import List from "../list/List";
import Datatable from "../../components/datatable/Datatable";
import { ProjectsTable } from "../../components/data/datatable2";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { createProject } from "../../../components/myFunctions";
import { db, auth } from "../../../firebase";
import ProjectTable from "../../../components/userProjects";



const Home = () => {
  let projectName = "";

  const [isCreateProjectVisible, setIsCreateProjectVisible] = useState(false);

  const handleCreateProjectClick = () => {
    setIsCreateProjectVisible(!isCreateProjectVisible);
  };



  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <div className="search">
          <input type="text" placeholder="Projects..." />
          
        </div>
        <div className="mainContent">
          <span className="uLine" onClick={handleCreateProjectClick}>Create Project<AddBoxIcon/></span>
          {isCreateProjectVisible && (
            <>
              <input className="uLine" type="text" onChange={ (event) => {
                projectName = event.target.value;
              } }  placeholder="Project name" />
              <span className="uLine" onClick={() => createProject(projectName)}><CheckBoxIcon /></span>
            </>
          )}
        
        <ProjectTable/>
        
        </div> 

        
      </div>
      {/*<AuthDetails/>*/}
    </div>
  );
};

export default Home;
